import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useParams, useSearchParams, Link } from 'react-router-dom'
import i18next, { t } from 'i18next'
import './login.css'

const VerifyEmail: React.FC = () => {
  const { token } = useParams()
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [, forceRender] = useState(0)
  const done = useRef(false)

  useEffect(() => {
    // язык из ссылки (?lang=xx), нормализуем старый 'ua' → 'uk'
    const lang = searchParams.get('lang')
    if (lang) i18next.changeLanguage(lang === 'ua' ? 'uk' : lang)
    const onChanged = () => forceRender(n => n + 1)
    i18next.on('languageChanged', onChanged)
    return () => { i18next.off('languageChanged', onChanged) }
  }, [searchParams])

  useEffect(() => {
    if (done.current) return
    done.current = true
    const verify = async () => {
      try {
        await axios.post('verify-email', { token })
        setStatus('success')
      } catch {
        setStatus('error')
      }
    }
    verify()
  }, [token])

  return (
    <div className='lp-root'>
      <div className='lp-mesh' />
      <div className='lp-mesh-noise' />
      <div className='lp-page'>
        <div className='lp-right'>
          <div className='lp-form-card'>
            <div className='lp-card-stripe' />
            <div className='lp-card-body' style={{ textAlign: 'center' }}>

              {status === 'loading' && (
                <>
                  <div className='lp-greeting'>{t('VerifyEmailVerifying')}</div>
                  <div className='lp-spinner' style={{ margin: '24px auto', borderTopColor: 'var(--lp-a1)' }} />
                </>
              )}

              {status === 'success' && (
                <>
                  <div style={{ fontSize: 46, marginBottom: 8 }}>🎉</div>
                  <div className='lp-greeting'>{t('VerifyEmailSuccessTitle')}</div>
                  <div className='lp-greeting-sub'>{t('VerifyEmailSuccessText')}</div>
                  <Link to='/login' className='lp-btn-submit' style={{ textDecoration: 'none', marginTop: 8 }}>
                    <span>{t('SignIn')}</span><span className='lp-btn-arrow'>→</span>
                  </Link>
                </>
              )}

              {status === 'error' && (
                <>
                  <div style={{ fontSize: 46, marginBottom: 8 }}>⚠️</div>
                  <div className='lp-greeting'>{t('VerifyEmailErrorTitle')}</div>
                  <div className='lp-greeting-sub'>{t('VerifyEmailErrorText')}</div>
                  <Link to='/login' className='lp-btn-submit' style={{ textDecoration: 'none', marginTop: 8 }}>
                    <span>{t('SignIn')}</span><span className='lp-btn-arrow'>→</span>
                  </Link>
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmail
